import { Outlet } from 'react-router-dom';
import Content from '../../../components/content';
import { useSettingsResourceLayout } from '@/hooks/use-settings-resource-layout';

export function PharmaciesLayout() {
    const { headerTitle, backNavLink } = useSettingsResourceLayout({
        createPath: { path: '/settings/pharmacy/create' },
        editPath: { path: '/settings/pharmacies/:pharmacyId/edit' },
        listBackPath: '/settings/pharmacies',
        labels: {
            list: 'Pharmacies',
            create: 'New Pharmacy',
            edit: 'Edit Pharmacy',
        },
    });

    return (
        <Content headerTitle={headerTitle} backNavLink={backNavLink}>
            {{ content: <Outlet /> }}
        </Content>
    );
}
